export * from './elo-icon.component'
export * from './visa-icon.component'
export * from './master-card-icon.component'
export * from './amex-icon.component'
export * from './hipercard-icon.component'
